import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './index.css';

// Modo embed: ?embed=1 esconde header e aplica padding menor (pra rodar dentro do Sigma via iframe)
const params = new URLSearchParams(window.location.search);
if (params.get('embed') === '1') {
  document.body.classList.add('embed');
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
